import { render } from "./Cross.vue?vue&type=template&id=058e79d8"
import script from "./Cross.vue?vue&type=script&lang=js"
export * from "./Cross.vue?vue&type=script&lang=js"

import "./Cross.vue?vue&type=style&index=0&id=058e79d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__